import { Link } from 'react-router'
import { Icon, type IIconsVector, Scrollbar, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type ItemUsageProps = {
  title: string
  description: string
  items: Array<{ link: string; key: string; icon: IIconsVector; title: string }>
}

export const ItemUsage = ({ title, description, items }: ItemUsageProps) => {
  return (
    <>
      <div className={styles.header}>
        <Icon fontSize={32} icon={'failed'} color={'var(--red-60)'} />
        <div className={styles.info}>
          <Typography ariaLabel={'title'} variant={'heading-lg'}>
            {title}
          </Typography>
          <Typography
            ariaLabel={'description'}
            variant={'body-rg-regular'}
            color={'var(--content-primary-secondary)'}
            className={styles.center}
          >
            {description}
          </Typography>
        </div>
      </div>
      <Scrollbar autoHeight autoHeightMax={256}>
        <div className={styles.list}>
          {items.map(({ key, link, icon, title }) => (
            <Link key={key} to={link} className={styles.card} target={'_blank'}>
              <Icon icon={icon} className={styles.icon} />
              <Typography
                ariaLabel={'title'}
                variant={'body-md-regular'}
                ellipsis
                className={styles.title}
              >
                {title}
              </Typography>
              <Icon icon={'chevronRight'} className={styles.icon} />
            </Link>
          ))}
        </div>
      </Scrollbar>
    </>
  )
}
